import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { isObjectNotEmpty } from "../../helpers/AppxUtils";
import { TvPlanContext } from "../../contexts/tvplancontext";

import TvPickGroup from "../TvPickGroup";
import TvService from "../TvService";


function TvPickList(props) {
    const { t } = useTranslation('tvplan');
    const ctx = useContext(TvPlanContext)
    const org = ctx.getOrg();
    const cfg = ctx.getTvConfig();
    const groups = cfg.picks?.groups || [];
    const picksGroup = cfg.picks?.group || {};
    const pickOthersLabel = cfg.pickOthersLabel || "Others";
    const service = cfg.service || {};
    const channels = cfg.channels || {};
    let servicesDone = {};
    let out = [];

    for (let code of groups) {
        let group = picksGroup[code];

        if (!isObjectNotEmpty(group)) {
            continue;
        }

        for (let scode of group.services) {
            servicesDone[scode] = true;
        }

        if (code !== 'movies') {
            let selected = ctx.isServiceSelected(code);
            let onClick = () => ctx.selectServiceClick(code);

            if (selected) {
                onClick = () => ctx.unselectServiceClick(code);
            }

            out.push(
                <TvPickGroup
                    key={`pick-group${code}`}
                    onClick={onClick}
                    pickMode={props.pickMode}
                    selected={selected}
                    code={code}
                />
            );
        }
    }

    out.push(
        <div
            key="pick-sep-other"
            className="tv-pick-group-sep">
            {t(pickOthersLabel)}
        </div>
    );

    let scodesArr = [];

    for (let scode in service) {
        let des = service[scode]?.des || "";

        if (des.length < 1) {
            let co = channels[scode] || {};
            let cdes = co.des || "";

            if (cdes.length > 0) {
                des = cdes;
            }
            else {
                des = scode;
            }
        }

        scodesArr.push({
            code: scode,
            des: des
        });
    }

    scodesArr.sort((a, b) => a.des.localeCompare(b.des));

    for (let scodeo of scodesArr) {
        let scode = scodeo.code || null;

        if (scode == null) { continue;}

        if (org === "ctal" && (scode === "foxn" || scode === "planete")) {
            continue;
        }

        if (scode === "aside") {
            continue;
        }

        if (servicesDone[scode]) { continue;}
        let selected = ctx.isServiceSelected(scode);
        let onClick = () => ctx.selectServiceClick(scode);

        if (selected) {
            onClick = () => ctx.unselectServiceClick(scode);
        }

        let sconfig = cfg.service[scode] || {};
        let sprice = sconfig.price || {};
        let pickPrice = sprice.pick || false;
        let saPrice = sprice.standalone || false;

        if (!pickPrice && !saPrice) {
            continue;
        }

        out.push(
            <TvService
                key={`pick-svc-${scode}`}
                tileSize="large"
                pickMode={props.pickMode}
                onClick={onClick}
                selected={selected}
                removeIfInStarter={true}
                code={scode}
            />
        );
    }

    return (
        <div className="tv-pick-list">{out}</div>
    );
}

export default TvPickList;
